module.exports = __webpack_public_path__ + "static/Konfest-73690d3773fd27e8f39d9af67d42f964.png";